import Image from "next/image";
import React from "react";
import MobileSlider from "./mobile-slider";
import { toWebp } from "@/utils/common";

interface FutureProps {
  data?: any;
  mobile?: boolean;
}
const WhatWe = ({ data }: FutureProps) => {

  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <section className="relative bg-background-dark text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
       
       <Image
        src="/images/about/top.png"
        width={571}
        height={571}
        alt="banner-vector"
        className="absolute w-[571px] h-[571px] top-[0] left-0 z-1 bg-cover bg-no-repeat bg-center "
        quality={80}
        loading="eager"
        priority
      />

      <Image
        src="/images/about/bottom.png"
        width={470}
        height={470}
        alt="banner-vector"
        className="absolute w-[470px] bottom-0 top-[auto] right-0 z-1 bg-cover bg-no-repeat bg-center  "
        quality={80}
        loading="eager"
        priority
      />

      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Heading */}
        <h2 className="text-heading-1 font-bold text-primary-text-white mb-[10px] text-center md:mt-[0px] max-w-[940px] mx-auto  w-full">
        {data?.title}
        </h2>
        <p className="text-subtitle-2 font-normal text-secondary-text-white xl:mb-[60px] mb-[32px] max-w-[940px] mx-auto">
        {data?.description}
        </p>
      </div>
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Desktop / Tablet Grid */}
        <div className="sm:block hidden">
          <div className="grid grid-cols-12 gap-[30px]">
            {data?.cards?.future_cards?.map((card: any, index: number) => (
              <div
                key={card.id}
                className={`${index === 0 ? "xl:col-span-8 sm:col-span-12" : "xl:col-span-4"
                  } sm:col-span-6 col-span-12 card-main`}
              >
                <div className="relative border-1 h-[517px] border-[rgba(64,66,76,1)] p-[32px_24px] group overflow-hidden ">
                  {card?.Image?.data?.attributes?.url && (
                    <Image
                      src={toWebp(baseUrl + card?.Image?.data?.attributes?.url)}
                      alt={card.title}
                      height={500}
                      width={1000}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  )}
                  <div
                    className="absolute inset-0 border border-[rgba(64,66,76,1)] 
                bg-[linear-gradient(180deg,#000000_0%,rgba(0,0,0,0)_50%), 
                linear-gradient(180deg,rgba(0,0,0,0)_19.88%,#000000_100%)]"
                  />
                  <div className="absolute inset-0 p-6 flex flex-col justify-end">
                    <h3 className="title-green text-heading-3 font-bold text-left absolute left-0 top-0 p-[32px_24px] max-w-[432px]">
                      {card?.title}
                    </h3>
                    <ul className="text-subtitle-2 text-white flex-wrap justify-start items-start text-left flex group-hover:text-white list-none pl-0">
                      {card?.description?.split("|").map((item: any, i: number) => (
                        <li
                          key={i}
                          className="after:content-['|'] after:px-2 last:after:content-['']"
                        >
                          {item.trim()}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Slider */}
        <div className="block sm:hidden">
          <MobileSlider>
            {data?.cards?.future_cards?.map((card: any) => (
              <div key={card.id} className="card-main">
                <div className="relative border-1 h-[517px] border-[rgba(64,66,76,1)] p-[32px_24px] group overflow-hidden ">
                  {card?.Image?.data?.attributes?.url && (
                    <Image
                      src={toWebp(baseUrl + card?.Image?.data?.attributes?.url)}
                      alt={card.title}
                      height={500}
                      width={1000}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  )}
                  <div
                    className="absolute inset-0 border border-[rgba(64,66,76,1)] 
                bg-[linear-gradient(180deg,#000000_0%,rgba(0,0,0,0)_50%), 
                linear-gradient(180deg,rgba(0,0,0,0)_19.88%,#000000_100%)]"
                  />
                  <div className="absolute inset-0 p-6 flex flex-col justify-end">
                    <h3 className="title-green text-heading-3 font-bold text-left absolute left-0 top-0 p-[32px_24px] max-w-[432px]">
                      {card?.title}
                    </h3>
                    <ul className="text-subtitle-2 text-white flex-wrap justify-start items-start text-left flex group-hover:text-white list-none pl-0">
                      {card?.description?.split("|").map((item: any, i: number) => (
                        <li
                          key={i}
                          className="after:content-['|'] after:px-2 last:after:content-['']"
                        >
                          {item?.trim()}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </MobileSlider>
        </div>
      </div>
    </section>
  );
};

export default WhatWe;
